import React, { useState } from "react";
import { toast } from "sonner";
import api from "../../console/api";

export function CrushDemandTable({ rows, onToggle }) {
  const [busy, setBusy] = useState("");
  const toggle = async (v) => {
    setBusy(v.variety_id);
    try {
      const r = await api.post(`/admin/crush/varieties/${v.variety_id}/toggle-closed`);
      toast.success(r.data.cuttings_closed ? `${v.name} , request button hidden on the club page.` : `${v.name} , open for requests again.`);
      await onToggle();
    } catch (e) { toast.error(e?.response?.data?.detail || "Couldn't update."); }
    finally { setBusy(""); }
  };
  if (!rows) return null;
  return (
    <section className="bg-white border border-[#E8DFCB] rounded-2xl overflow-hidden" data-testid="crush-demand">
      <div className="px-4 py-3 border-b border-[#F3EBDD] text-xs text-[#7A6A55]">Who's popular. Audited stock and growing-folder numbers are shown here for your eyes only , they never appear on the public page.</div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-[9px] tracking-[0.2em] uppercase text-[#6E1E3A] text-left bg-[#FBF6E9]">
            <th className="px-4 py-2">Variety</th><th className="px-2">Requests</th><th className="px-2">Customers</th><th className="px-2">Cuttings wanted</th><th className="px-2">Approved</th><th className="px-2">Audited stock</th><th className="px-2">In growing folders</th><th className="px-2">Requests open?</th>
          </tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={8} className="px-4 py-8 text-center text-[#9C8B73] italic">No demand yet , the club just opened.</td></tr>}
            {rows.map((v) => (
              <tr key={v.variety_id} className="border-t border-[#F3EBDD]" data-testid={`crush-demand-${v.variety_id}`}>
                <td className="px-4 py-2 font-medium text-[#3E1F46]">{v.name}</td>
                <td className="px-2 font-bold">{v.requests}</td><td className="px-2">{v.customers}</td><td className="px-2">{v.cuttings}</td><td className="px-2 text-[#2F6B4F]">{v.approved}</td>
                <td className="px-2">{v.audited_stock}</td><td className="px-2">{v.in_growing_folders}</td>
                <td className="px-2">
                  <button type="button" disabled={busy === v.variety_id} onClick={() => toggle(v)} data-testid={`crush-demand-toggle-${v.variety_id}`}
                    className={`h-7 px-3 rounded-full text-[10px] tracking-[0.15em] uppercase font-bold ${v.cuttings_closed ? "bg-[#A33030] text-white" : "bg-[#E4F0E8] text-[#2F6B4F]"}`}>
                    {v.cuttings_closed ? "Closed" : "Open"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
